import React from 'react';
import { createRoot } from 'react-dom/client';
import PopArt from '../components/PopArt';
const projectContainer = document.getElementById('pop-art-page');

if (projectContainer) {
  const root = createRoot(projectContainer);
  root.render(
    // <React.StrictMode> // Optional, good for development
      <PopArt />
    // </React.StrictMode>
  );
} else {
  console.error("Root element for PopArt (#pop-art-page) not found. Check your Rails view.");
}